module.exports = __webpack_public_path__ + "static/media/026.65e539d7.jpg";